import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newbuildingIdSelector, promosSelector } from '../../selectors';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';
import { Promos } from '../../components/Promos';
import { PromoItem } from '../../components/Promos/PromoItem';
import { openPromoInfo } from '../../actions/promoInfo';
import { FlatsError } from '../../components/FlatsError';
import { ToggleButtonContainer } from './ToggleButton';
import { trackClickPromoBlock } from '../../analytics/promos';

export const PromosContainer = () => {
  const promos = useSelector(promosSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);
  const dispatch = useDispatch();

  const openPromo = React.useCallback(
    (promo: IPromoInfo) => {
      dispatch(openPromoInfo({ promo }));
      trackClickPromoBlock(promo, newbuildingId);
    },
    [dispatch, newbuildingId],
  );

  if (!promos || !promos.length) {
    return <FlatsError />;
  }

  return (
    <Promos Button={ToggleButtonContainer}>
      {promos.map((promo: IPromoInfo) => (
        <PromoItem key={promo.uniquePromoId} promo={promo} onClick={() => openPromo(promo)} />
      ))}
    </Promos>
  );
};
